import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../store';
import { createService } from '../../store/feature/serviceSlice'; // Redux action
import Swal from 'sweetalert2';

const AddService: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const token = localStorage.getItem('token') || '';
  // Form input state'leri
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [photo, setPhoto] = useState<File | null>(null);

  // Fotoğraf seçimi
  const handlePhotoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setPhoto(event.target.files[0]);
    }
  };

  // Form submit işlemi
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!photo) {
      Swal.fire('Error', 'Please select a photo for the service.', 'error');
      return;
    }
    console.log(token, title, content, photo);
    const formData = new FormData();
    formData.append('token', token);
    formData.append('title', title);
    formData.append('content', content);
    formData.append('photo', photo);

    try {
      await dispatch(createService(formData)).unwrap();
      Swal.fire('Başarılı', 'Hizmet Başarıyla Eklendi!', 'success');
      setTitle('');
      setContent('');
      setPhoto(null);
    } catch (err) {
      Swal.fire('Error', 'An error occurred while adding the service.', 'error');
      console.error('Error adding service:', err);
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Yeni Hizmet Ekle</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          name="title"
          placeholder="Başlık"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
        <textarea
          name="content"
          placeholder="İçerik"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
        <input
          type="file"
          name="photo"
          accept="image/*"
          onChange={handlePhotoChange}
          className="w-full p-2 border rounded"
          required
        />
        <button
          type="submit"
          className="w-full py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition duration-300"
        >
          EKLE
        </button>
      </form>
    </div>
  );
};

export default AddService;
